"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var formik_1 = require("formik");

var styled_1 = __importDefault(require("@emotion/styled"));

var CheckboxLabel = styled_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  position: relative;\n  margin-bottom: 10px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  align-items: center;\n"], ["\n  display: flex;\n  position: relative;\n  margin-bottom: 10px;\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  align-items: center;\n"])));
var CheckboxInput = styled_1.default.input(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n"], ["\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n"])));
var CheckboxCheckmark = styled_1.default.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  height: 1.2em;\n  width: 1.2em;\n  background-color: transparent;\n  border: 1px solid #999;\n  transition: 0.5s;\n  border-radius: 4px;\n  margin-right: 0.4em;\n\n  &:after {\n    content: '';\n    position: absolute;\n    display: ", ";\n    left: 0.4em;\n    top: 0.45em;\n    width: 0.3em;\n    height: 0.4em;\n    border: solid ", ";\n    border-width: 0 0.15em 0.15em 0;\n    transform: rotate(45deg);\n  }\n"], ["\n  height: 1.2em;\n  width: 1.2em;\n  background-color: transparent;\n  border: 1px solid #999;\n  transition: 0.5s;\n  border-radius: 4px;\n  margin-right: 0.4em;\n\n  &:after {\n    content: '';\n    position: absolute;\n    display: ", ";\n    left: 0.4em;\n    top: 0.45em;\n    width: 0.3em;\n    height: 0.4em;\n    border: solid ", ";\n    border-width: 0 0.15em 0.15em 0;\n    transform: rotate(45deg);\n  }\n"])), function (props) {
  return props.checked ? 'block' : 'none';
}, function (_a) {
  var theme = _a.theme;
  return theme.colors.default.color;
});

var StandardInput = function StandardInput(_a) {
  var field = _a.field,
      errors = _a.form.errors,
      // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
  label = _a.label;
  return react_1.default.createElement("div", {
    key: field.name
  }, react_1.default.createElement("div", null, react_1.default.createElement(CheckboxLabel, {
    htmlFor: field.name
  }, react_1.default.createElement(CheckboxCheckmark, {
    checked: field.value
  }), label, react_1.default.createElement(CheckboxInput, __assign({
    id: field.name,
    type: "checkbox"
  }, field))), react_1.default.createElement("div", null, errors ? errors[field.name] : null)));
};

exports.CheckboxField = function (props) {
  return react_1.default.createElement(formik_1.Field, __assign({}, props, {
    component: StandardInput
  }));
};

var templateObject_1, templateObject_2, templateObject_3;